import React from 'react'
import {
    coursPreparatoiresTocFilter,
    horaireDesCoursTocFilter,
    inscriptionUnitesPreparatoiresTocFilter,
    isGenieTerritorial,
    isHeg,
    isPt,
    journeeAccueilTocFilter,
    verificationNiveauMathTocFilter,
    isGerman, isEcg, isIgis
} from './lib/utils'
import Student from './Student'
import styles from './TOC.module.css'
import TOCEntry from './TOCEntry'

const seesAhesMenu = ({ ahesRequired, visaRequired, visaAcquired }) =>
    ahesRequired && (!visaRequired || visaAcquired)

const isHegAndPt = (student) => isHeg(student) && isPt(student)

const cantSeeVerificationNiveauxLangues = (student) => isGenieTerritorial(student) || isIgis(student)

export default ({ disabled, onNavigate }) => {
    const { student } = Student.useContainer()
    return (
        <div className={styles.root}>
            <div className={styles.section}>
                <TOCEntry onNavigate={onNavigate} to="/2026/accueil">Accueil</TOCEntry>
                <span className={styles.title}>A effectuer de suite</span>
                <ul className={styles.list}>
                    <TOCEntry onNavigate={onNavigate} to="/2026/comptes-acces">Comptes d'accès</TOCEntry>
                    {seesAhesMenu(student) && (
                        <TOCEntry onNavigate={onNavigate} to="/2026/financement-de-vos-etudes" disabled={disabled}>
                            Financement de vos études – Formulaire AHES à remplir
                        </TOCEntry>
                    )}
                    {!cantSeeVerificationNiveauxLangues(student) && (
                        <TOCEntry onNavigate={onNavigate} to="/2026/verification-niveaux-langues" disabled={disabled}>
                            Vérification des niveaux de langues
                        </TOCEntry>
                    )}
                    {verificationNiveauMathTocFilter(student) && (
                        <TOCEntry onNavigate={onNavigate} to="/2026/evaluation-niveau-math" disabled={disabled}>
                            Auto-contrôle des prérequis en mathématiques
                        </TOCEntry>
                    )}
                    <TOCEntry onNavigate={onNavigate} to="/2026/code-de-savoir-vivre" disabled={disabled}>
                        Code de savoir-vivre
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/assurance-maladie-et-accident" disabled={disabled}>
                        Assurance maladie et accident
                    </TOCEntry>
                    {isHegAndPt(student) && (
                        <>
                            <TOCEntry onNavigate={onNavigate} to="/2026/cours-marketing" disabled={disabled}>
                                Cours de marketing en français ou en anglais
                            </TOCEntry>
                        </>
                    )}
                </ul>
            </div>
            <div className={styles.section}>
                <span className={styles.title}>Préparation</span>
                <ul className={styles.list}>
                    <TOCEntry onNavigate={onNavigate} to="/2026/preparation-a-l-immatriculation" disabled={disabled}>
                        Votre immatriculation
                    </TOCEntry>
                    {coursPreparatoiresTocFilter(student) && (
                        <TOCEntry onNavigate={onNavigate} to="/2026/cours-preparatoires" disabled={disabled}>
                            Inscription aux cours préparatoires
                        </TOCEntry>
                    )}
                    {inscriptionUnitesPreparatoiresTocFilter(student) && (
                        <TOCEntry onNavigate={onNavigate} to="/2026/inscription-unites-preparatoires" disabled={disabled}>
                            Inscription aux unités préparatoires
                        </TOCEntry>
                    )}
                    <TOCEntry onNavigate={onNavigate} to="/2026/demande-equivalence" disabled={disabled}>
                        Demande d'équivalence
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/ordinateur-portable" disabled={disabled}>
                        Ordinateur portable
                    </TOCEntry>
                </ul>
            </div>
            <div className={styles.section}>
                <span className={styles.title}>Rentrée académique</span>
                <ul className={styles.list}>
                    {journeeAccueilTocFilter(student) && (
                        <TOCEntry onNavigate={onNavigate} to="/2026/journee-d-accueil" disabled={disabled}>
                            Journée d’accueil - Présence obligatoire
                        </TOCEntry>
                    )}
                    <TOCEntry onNavigate={onNavigate} to="/2026/rentree-et-calendrier-academique" disabled={disabled}>
                        Rentrée et calendrier académique
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/attestation-d-etudes" disabled={disabled}>
                        Attestation d’études
                    </TOCEntry>
                </ul>
            </div>
            <div className={styles.section}>
                <span className={styles.title}>Informations importantes</span>
                <ul className={styles.list}>
                    <TOCEntry onNavigate={onNavigate} to="/2026/taxe-annuelle-etudes" disabled={disabled}>
                        Taxe annuelle d'études
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/votre-carte-etudiant-e" disabled={disabled}>
                        Votre carte d'étudiant&#903;e
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/guide-de-l-etudiant-e" disabled={disabled}>
                        Guide de l’étudiant&#903;e
                    </TOCEntry>
                    {horaireDesCoursTocFilter(student) && (
                        <TOCEntry onNavigate={onNavigate} to="/2026/horaire-des-cours" disabled={disabled}>
                            Horaire des cours
                        </TOCEntry>
                    )}
                    <TOCEntry onNavigate={onNavigate} to="/2026/problemes-sante-specifiques" disabled={disabled}>
                        Problèmes de santé spécifiques
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/situation-de-handicap-ou-maladie" disabled={disabled}>
                        Situation de handicap ou maladie
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/studios-appartements-chambres" disabled={disabled}>
                        Studios / Appartements / Chambres
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/mobilite" disabled={disabled}>
                        Mobilité - Venir à la HEIG-VD
                    </TOCEntry>
                    <TOCEntry onNavigate={onNavigate} to="/2026/renonciation" disabled={disabled}>
                        Renonciation
                    </TOCEntry>
                </ul>
            </div>
        </div>
    )
}
